<div class="loading-page vd-hero-bg">
  <!-- Couches d'aurore animées en arrière-plan -->
  <div class="aurora aurora-1" aria-hidden="true"></div>
  <div class="aurora aurora-2" aria-hidden="true"></div>
  <div class="aurora aurora-3" aria-hidden="true"></div>

  <main class="loading-card vd-glass-strong vd-scale-in">
    <div class="logo-ring">
      <div class="ring-orbit" aria-hidden="true"></div>
      <div class="ring-orbit ring-orbit-2" aria-hidden="true"></div>
      <app-brand-logo size="xl" [animated]="true"></app-brand-logo>
    </div>

    <h1 class="brand-title vd-gradient-text">Vendeur.site</h1>
    <p class="brand-subtitle">{{ statusMessage() }}</p>

    <!-- Steps -->
    <ol class="steps" aria-label="Étapes de chargement">
      <li
        *ngFor="let s of steps; let i = index"
        class="step"
        [class.active]="isStepActive(i)"
        [class.done]="isStepDone(i)"
        [class.error]="isError() && isStepActive(i)"
      >
        <span class="step-dot" aria-hidden="true">
          <span class="step-dot-inner"></span>
          <svg *ngIf="isStepDone(i)" class="step-check" viewBox="0 0 24 24" fill="none">
            <path d="M5 12l5 5L20 7" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="step-text">
          <span class="step-label">{{ s.label }}</span>
          <span class="step-desc">{{ s.description }}</span>
        </span>
      </li>
    </ol>

    <!-- Barre de progression -->
    <div class="progress" role="progressbar" [attr.aria-valuenow]="progress()" aria-valuemin="0" aria-valuemax="100">
      <div class="progress-bar" [style.width.%]="progress()" [class.error]="isError()">
        <span class="progress-shine"></span>
      </div>
    </div>
    <div class="progress-label">{{ progress() | number:'1.0-0' }} %</div>
  </main>

  <p class="footer-note">© Vendeur.site — propulsé par CodinCloud</p>
</div>
